import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutModule as Layout } from '@angular/cdk/layout';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { LogoComponent } from './logo/logo.component';
import { NavigationComponent } from './navigation/navigation.component';
import { PageTitleComponent } from './page-title/page-title.component';
import { FooterWrapperComponent } from './footer-wrapper/footer-wrapper.component';
import { PortfolioSelectorComponent } from './portfolio-selector/portfolio-selector.component';
import { PortfolioSettingComponent } from './portfolio-setting/portfolio-setting.component';
import { SharedModule } from '../shared/shared.module';

const LayoutComponents = [
  { name: 'Header', type: HeaderComponent },
  { name: 'Logo', type: LogoComponent },
  { name: 'Navigation', type: NavigationComponent },
  { name: 'PortfolioSelector', type: PortfolioSelectorComponent },
  { name: 'PortfolioSetting', type: PortfolioSettingComponent },
  { name: 'PageTitle', type: PageTitleComponent },
  { name: 'Footer', type: FooterComponent }
];

@NgModule({
  imports: [
    CommonModule,
    JssModule,
    RouterModule,
    Layout,
    MatLegacyMenuModule,
    MatLegacyTooltipModule,
    SharedModule
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    LogoComponent,
    NavigationComponent,
    PageTitleComponent,
    FooterWrapperComponent,
    PortfolioSelectorComponent,
    PortfolioSettingComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    LogoComponent,
    NavigationComponent,
    PageTitleComponent,
    FooterWrapperComponent
  ]
})
export class LayoutModule {}
export { LayoutComponents };
